var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodataTopSites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-nodata_top_sites"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nodata_top_sites",
    clipPath: "url(#clip-nodata_top_sites)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6245",
    "data-name": "Group 6245",
    transform: "translate(19252.252 -15960.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-19224.016 16004.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18361",
    "data-name": "Path 18361",
    d: "M92.933,69.844c0,11.895-15.085,16.667-15.085,16.667H9.494A9.505,9.505,0,0,1,0,77.017V62.671a9.505,9.505,0,0,1,9.494-9.494H77.849S92.933,57.949,92.933,69.844Z",
    transform: "translate(0 -53.177)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18362",
    "data-name": "Path 18362",
    d: "M92.933,132.177c0,11.895-15.085,16.667-15.085,16.667H9.494A9.505,9.505,0,0,1,0,139.35v-7.173Z",
    transform: "translate(0 -115.51)",
    fill: "#d2def2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18363",
    "data-name": "Path 18363",
    d: "M389.675,53.177H369V86.511h20.675a9.505,9.505,0,0,0,9.494-9.494V62.671a9.505,9.505,0,0,0-9.494-9.494Z",
    transform: "translate(-291.151 -53.177)",
    fill: "#34c6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18364",
    "data-name": "Path 18364",
    d: "M369,132.177v16.667h20.675a9.505,9.505,0,0,0,9.494-9.494v-7.173Z",
    transform: "translate(-291.151 -115.51)",
    fill: "#33bcaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18365",
    "data-name": "Path 18365",
    d: "M168.475,205.128l-11.54-18.763a24.246,24.246,0,1,0-22.384,4.506,24.331,24.331,0,0,0,7,1.034,24.043,24.043,0,0,0,10.016-2.192l11.52,18.731a3.164,3.164,0,1,0,5.391-3.316Z",
    transform: "translate(-92.527 -124.371)",
    fill: "#34c6b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18366",
    "data-name": "Path 18366",
    d: "M118.3,171.569a24.237,24.237,0,0,0,16.251,30.18,24.33,24.33,0,0,0,7,1.034,24.043,24.043,0,0,0,10.016-2.192l11.52,18.731a3.164,3.164,0,0,0,4.354,1.038l-37.413-63.166A24.079,24.079,0,0,0,118.3,171.569Z",
    transform: "translate(-92.527 -135.248)",
    fill: "#33bcaf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_714",
    "data-name": "Ellipse 714",
    cx: 17.917,
    cy: 17.917,
    r: 17.917,
    transform: "translate(31.072 25.371)",
    fill: "#d2def2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18367",
    "data-name": "Path 18367",
    d: "M156.934,183.016A17.917,17.917,0,1,0,175.167,213.8Z",
    transform: "translate(-116.21 -155.624)",
    fill: "#e0eaf6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "note",
    transform: "translate(-19249 15980.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18317",
    "data-name": "Path 18317",
    d: "M51.095,182.856a1.747,1.747,0,0,0-2.47,0l-1.235,1.235-1.235-1.235a1.747,1.747,0,0,0-2.47,2.47l1.235,1.235L43.684,187.8a1.747,1.747,0,1,0,2.47,2.47l1.235-1.235,1.235,1.235a1.747,1.747,0,0,0,2.47-2.47l-1.235-1.235,1.235-1.235A1.746,1.746,0,0,0,51.095,182.856Z",
    transform: "translate(-43.173 -148.426)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_706",
    "data-name": "Ellipse 706",
    cx: 1.747,
    cy: 1.747,
    r: 1.747,
    transform: "translate(14.699 27.32)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6210",
    "data-name": "Group 6210",
    transform: "translate(41.458 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_709",
    "data-name": "Ellipse 709",
    cx: 1.464,
    cy: 1.464,
    r: 1.464,
    transform: "translate(0 14.513)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_710",
    "data-name": "Ellipse 710",
    cx: 2.904,
    cy: 2.904,
    r: 2.904,
    transform: "translate(60.275 6.755)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18323",
    "data-name": "Path 18323",
    d: "M525.055,62.47h0a6.452,6.452,0,0,0,5.049,5.049h0a6.464,6.464,0,0,0-5.049,5.055h0A6.458,6.458,0,0,0,520,67.519h0a6.446,6.446,0,0,0,5.049-5.049Z",
    transform: "translate(-493.46 -62.47)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18324",
    "data-name": "Path 18324",
    d: "M613,168.62h0a4.125,4.125,0,0,0,3.226,3.226h0A4.125,4.125,0,0,0,613,175.072h0a4.119,4.119,0,0,0-3.226-3.226h0A4.119,4.119,0,0,0,613,168.62Z",
    transform: "translate(-513.382 -150.06)",
    fill: "#e0eaf6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataTopSites);
export default __webpack_public_path__ + "static/media/nodata_top_sites.8f1549efb986e129c7f2630e972dac38.svg";
export { ForwardRef as ReactComponent };